import React, { useState, useEffect, Component } from "react";
import Moment from "moment";
import { Link } from "react-router-dom";
import BackgroundDiv from "../shared/BackgroundDiv";
import { t } from "../../../i18n";
import { ArrowLeftLG } from "../normalizer";
import CustomButton from "../shared/CustomButton";

function getDeviceType() {
  return window.innerWidth < 740 ? 'mobile' : 'desktop';
}

export default class Details extends Component {
  state = {
    deviceType: getDeviceType()
  };

  componentDidMount() {
    const { announcement } = this.props;
    const element = document.getElementById(`announcement-${announcement.id}`);

    let resize = -20;
    const { offsetHeight } = document.getElementById("g-navbar");
    resize = -offsetHeight - 10;

    window.scrollTo(0, element.offsetTop + resize);

    window.addEventListener('resize', this.updateDeviceType);
    this.updateDeviceType();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDeviceType);
  }

  updateDeviceType = () => {
    this.setState({ deviceType: getDeviceType() });
  };

  render() {
    const { announcement } = this.props;
    const { deviceType } = this.state;

    const imageSize = deviceType === 'mobile' ? 'banner_mobile_image' : 'banner_desktop_image';
    const croppedImageKey = imageSize.replace('image', 'cropped_image');

    const imageUrl = announcement.image[croppedImageKey] && announcement.image[croppedImageKey].url
                    ? announcement.image[croppedImageKey].url
                    : (announcement.image[imageSize] ? announcement.image[imageSize].url : "");

    return (
      <div
        className="announcement-detail"
        id={`announcement-${announcement.id}`}
      >
        <CustomButton link small tight to="/news" className="announcement-detail__close">
          <ArrowLeftLG className="announcement-detail__close-icon" />
          <div className="announcement-detail__close-text">Voltar</div>
        </CustomButton>
        {/* Title above the banner image, per design */}
        <div className="announcement-detail__content">
          <div className="announcement-detail__title">
            <h2 className="announcement-detail__title-content">
              {announcement.title}
            </h2>
          </div>
        </div>
        <div className="announcement-detail__image">
          <img
            src={imageUrl}
            className="announcement-detail__image-content"
            alt={announcement.title}
          />
        </div>
        <div className="announcement-detail__content">
          <div className="announcement-detail__body">
            <div className="announcement-detail__body-content"
              dangerouslySetInnerHTML={{ __html: announcement.news_body }}
            />
          </div>
          {/* <p className="announcement-detail__date">
            {new Moment(announcement.created_at).format(t("date-format"))}
          </p> */}
        </div>
      </div>
    )
  }
}
